<template>
    <page-layout class="bg-wedding">
        <create-wedding-list/>
    </page-layout>
</template>
<script>
import { defineComponent } from 'vue';
import PageLayout from '@components/Layout/PageLayout.vue';
import CreateWeddingList from '@components/Wishlist/CreateWeddingList.vue';
import { useAppStore } from '@stores/App';

export default defineComponent({
    components: { CreateWeddingList, PageLayout },
    data() {
        const app = useAppStore();
        return {
            app: app,
        };
    },
    computed: {},
    async mounted() {
        this.app.setTheme('wedding');
    },
    unmounted() {
        this.app.resetTheme();
    },
    methods: {},
});
</script>
<style lang="scss" scoped>
::v-global(.main-account-wedding-list-create) {
    background: #dff2f0;
}
</style>
